import { PageTypeSuffix } from '@/constants'
import type { ProductCatModal } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Link from 'next/link'

interface BreadcrumbType {
  breadcrumb?: ProductCatModal
  translateText?: string
}

const Breadcrumb = ({ breadcrumb, translateText }: BreadcrumbType) => {
  return (
    <div className='breadCrumb'>
      <ul className='flex list-none items-center gap-1 text-base'>
        <li>
          <Link href='/' className='home block text-blue'>
            {translateText || 'Trang chủ'}
          </Link>
        </li>
        {!!breadcrumb && (
          <>
            <li className='divider'>{'/'}</li>
            <li>
              <Link
                href={`/${
                  getTranslate(breadcrumb.slugs.value) + PageTypeSuffix.CATEGORY
                }`}
                className='block text-blue'
              >
                {getTranslate(breadcrumb.name)}
              </Link>
            </li>
          </>
        )}
      </ul>
    </div>
  )
}
export default Breadcrumb
